import React from "react";

/**
 * Single fixed background — same approach as the /video page.
 * The full floral template stays in place while the content scrolls over it.
 * No slicing, no masks, no seams.
 */
export default function FloralFrame() {
  return (
    <div
      aria-hidden
      data-testid="floral-frame"
      className="pointer-events-none fixed inset-0 z-0"
      style={{
        backgroundImage: "url('/images/template-mobile.png?v=3')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundColor: "#F7EEDC",
      }}
    />
  );
}
